<template>
    <div class="home-page-component-container">
        <div class="component-wrapper">
            <AppHeader />
            <div class="home-page-container">
                <div v-if="loadingPage" class="spinner-container">
                    <div class="spinner">
                        <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                    </div>
                </div>
                <div v-if="successLoadingPage && !loadingPage" class="cards-list-container">
                    <div v-if="!$store.showStudiosOptionsPage" class="cards-list-wrapper">
                        <!-- <div class="search-bar-container" :class="$store.showHomePageSearchBar ? 'show' : 'hide'" ref="searchBarContainer">
                            <input type="text" class="search-bar" id="search-bar" placeholder="Zoeken..."
                                @keyup="searchHandle($event.target.value)" ref="searchBar"/> -->
                        <!-- <div class="search-bar-container" :class="$store.showHomePageSearchBar ? 'show' : 'hide'"
                            ref="searchBarContainer">
                            <input type="text" class="search-bar" id="search-bar" :placeholder="$t('search') + '...'"
                                @keyup="searchHandle($event.target.value)" ref="searchBar" />
                            <div class="close-btn-container">
                                <img src="../../assets/icons/close.png" alt="Close Icon" class="close-btn"
                                    @click="closeSearchBar">
                            </div>
                        </div> -->
                        <ul class="cards-list">
                            <!-- <div class="test" @click="getStudiosHandle">Get Studios</div> -->
                            <!-- <li v-for="(card, index) in searchCardsArr" class="card-item" :key="card.fixed_card ? `fixed-${index}` : `temp-${index}`" @click="(typeof card.redirection_info == 'string') ? (card.redirection_info ? openUrlClickHandle(card.redirection_info) : '') : (card.redirection_info.length > 1 ? showStudiosOptionsPageHandle(card.id, card.redirection_info) : openUrlClickHandle(card.redirection_info[0].website))"> -->
                            <li v-for="(card, index) in searchCardsArr" class="card-item"
                                :key="card.fixed_card ? `fixed-${index}` : `temp-${index}`" :class="!card.active ? 'hidden' : ''"
                                @click="card.action ? card.action(card.id) : ''">
                                <!-- <div v-if="!card.active" class="coming-soon-container">
                                    <p>{{ $t('coming_soon') }}</p>
                                </div> -->
                                <div class="card-bg-container">
                                    <img class="card-bg" :src="card.img_url" alt="Card Image">
                                </div>
                                <div class="card-title-container">
                                    <p class="card-title">{{ $t(`${card.id}`) }}</p>
                                </div>
                                <div class="forward-arrow-icon-container">
                                    <img src="../../assets/icons/navigation.png" alt="Navigation Icon">
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div v-else class="studios-options-page-container">
                        <div class="studios-options-page-wrapper">
                            <div class="info-text-container">
                                <p class="info-text">
                                    {{ $t('select_studio') }}
                                </p>
                            </div>
                            <div class="studios-options-list-container">
                                <ul class="studios-options-list">
                                    <li v-for="(studio, index) in $store.user.studiosInfo" :key="index"
                                        class="studios-options-item"
                                        @click="optionsType == 'my_studio' ? openUrlClickHandle(studio.website) : ''">
                                        <div class="studio-name-container" @click="openUrlClickHandle(studio.website)">
                                            <p>{{ studio.name }}</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="back-to-homepage-btn-container" @click="backToHomePageHandle">
                                <p class="back-to-homepage-btn">{{ $t('back_to_homepage') }}</p>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-if="failedLoadingPage" class="fialed-loading-page-container">
                    <div class="info-text-container">
                        <p class="info-text">
                            {{ $t('something_went_wrong_try_again') }}
                        </p>
                    </div>
                    <div class="reload-btn-container">
                        <div class="reload-btn" @click="reloadPage">{{ $t('reload') }}</div>
                    </div>
                </div>
            </div>
            <AppFooter />
        </div>

        <!-- <div v-if="failedGetStudiosInfo || failedGetNewsLink || failedGetUserProgress || faildGetData"
            class="error-msg-container">
            <div class="error-msg-wrapper">
                <div class="error-msg-text-container">
                    <p v-if="failedGetStudiosInfo">No studios found</p>
                    <p v-else-if="failedGetNewsLink">No news found</p>
                    <p v-else-if="failedGetUserProgress">No results found</p>
                    <p v-else-if="faildGetData">Something went wrong. Try again</p>
                </div>
                <div class="ok-btn-container">
                    <div class="ok-btn" @click="closeErrPopup">{{ $t('ok') }}</div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
/* eslint-disable */
import AppHeader from './AppHeader.vue';
import AppFooter from './AppFooter.vue';
const { getUserStudios, fetchProgressData } = require("../../actions/userActions");
export default {
    name: 'HomePage',
    components: {
        AppHeader,
        AppFooter,
    },
    props: {
        // requestSource: String,
    },
    data() {
        return {
            firstName: this.$store.user.firstName,
            loginLoading: false,
            loginSuccesseded: false,
            // cards: [
            //     {
            //         "title": "Mijn resultaten",
            //         "img_url": "https://storage.googleapis.com/fit20_client_app/imgs/home_titles/my_results.jpg",
            //         "external_url": false,
            //         "fixed_card": true,
            //         "active": true
            //     },
            //     {
            //         "title": "fit20 nieuws",
            //         "img_url": "https://storage.googleapis.com/fit20_client_app/imgs/home_titles/fit20_news.jpg",
            //         "external_url": true,
            //         "fixed_card": true,
            //         "active": true
            //     },
            //     {
            //         "title": "Mijn studio",
            //         "img_url": "https://storage.googleapis.com/fit20_client_app/imgs/home_titles/my_studio.jpg",
            //         "external_url": true,
            //         "fixed_card": true,
            //         "active": true
            //     },
            //     {
            //         "title": "Mijn investering",
            //         "img_url": "https://storage.googleapis.com/fit20_client_app/imgs/home_titles/my_investment.jpg",
            //         "external_url": true,
            //         "fixed_card": true,
            //         "active": true
            //     },
            //     {
            //         "title": "Mijn afspraken",
            //         "img_url": "https://storage.googleapis.com/fit20_client_app/imgs/home_titles/my_appointment.jpg",
            //         "external_url": true,
            //         "fixed_card": true,
            //         "active": true
            //     }
            // ],
            loadingPage: true,
            failedLoadingPage: false,
            successLoadingPage: false,
            cards: [],
            searchCardsArr: [],
            optionsType: '',
            studiosOptionsArr: [],
            failedGetStudiosInfo: false,
            failedGetNewsLink: false,
            failedGetUserProgress: false,
            faildGetData: false,
        };
    },
    methods: {
        loginMobileApp: async function (email, mobileId) {
            this.loginFailed = false;
            this.loginSuccesseded = false;

            try {
                const params = `${email}/${mobileId}`;
                const loginResponse = await fetch(`/api/user/mobileAppLogin/${params}`);

                const loginResponseJson = await loginResponse.json();
                // console.log(loginResponseJson);

                if (!loginResponseJson.status) {
                    // if (loginResponseJson.invalidToken) {
                    //     this.$store.showErrorPopup = true;
                    //     this.$store.errorPopupTitle = 'logout';
                    //     this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    //     this.$store.mustLogOut = true;
                    // }
                    // else {
                    //     this.loginErrorMsg = loginResponseJson.message;
                    //     this.loginFailed = true;
                    //     this.$router.push('/login');
                    // }
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    if (loginResponseJson.token && loginResponseJson.token != '') {
                        // console.log("this.$store.user.newsLink: " + this.$store.user.newsLink);
                        // console.log("loginResponseJson.newsLink: " + loginResponseJson.newsLink);
                        // this.$store.user.email = loginResponseJson.email;
                        this.$store.user.confirmedEmail = loginResponseJson.user.confirmInfo.status;
                        this.$store.user.token = loginResponseJson.token;
                        this.$store.user.firstName = loginResponseJson.user.firstName;
                        this.$store.user.lastName = loginResponseJson.user.lastName;
                        this.$store.user.country_code = loginResponseJson.studiosInfo[0].country_code;
                        this.$store.user.zohoId = loginResponseJson.user.zohoId;
                        this.$store.selectedAppLanguage = loginResponseJson.user.appLanguage;
                        this.$store.user.moduleType = loginResponseJson.user.moduleType;
                        this.$store.user.newsLink = loginResponseJson.newsLink;
                        this.$store.user.studiosInfo = loginResponseJson.studiosInfo;
                        this.$store.user.type = loginResponseJson.user.type;
                        this.$store.user.mobileId = mobileId;
                        this.$store.user.email = email;
                        this.$store.planning = loginResponseJson.planning;

                        // Check if the the profile image of the user exists on the server
                        const url = `https://storage.googleapis.com/fit20_client_app/imgs/clients_profile_photos/${loginResponseJson.user.zohoId}.png`;
                        const profileImgExist = await this.$store.checkOnlineImageExist(url);
                        // console.log("profileImgExist: " + profileImgExist);
                        if (profileImgExist) {
                            this.$store.user.profileImgUrl = url;
                        }
                        else {
                           this.$store.user.profileImgUrl = require("@/assets/imgs/placeholder_user_img.png");
                        }
                        
                        const localStorageData = {
                            email: email,
                            token: loginResponseJson.token,
                        }
                        this.$store.tempMobileLogin = true;
                        this.$store.setLocalStorage('user', localStorageData);
                        this.$store.activeNavBarButton = 'home';
                        await this.getHomePageData();
                    }
                    else {
                        // this.loginErrorMsg = 'The session is expired. Please log in again.';
                        // this.loginFailed = true;
                        // this.loginLoading = false;
                        // this.$router.push('/login');
                        this.$store.showErrorPopup = true;
                        this.$store.errorPopupTitle = 'logout';
                        this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                        this.$store.mustLogOut = true;
                    }
                }
            }
            catch (err) {
                console.log("something_went_wrong_try_again");
                console.log(err);
                this.loginErrorMsg = 'something_went_wrong_try_again';
                this.loginFailed = true;
                this.loginLoading = false;
                // this.$router.push('/login');
            }
        },
        logOutHandle: async function () {
            await this.$store.logOut();
            this.$router.push("/login");
        },
        openUrlClickHandle: async function (url) {
            // console.log("url: " + url);
            if (url && url != '') {
                await this.$store.openExternalUrl(url);
                // window.open(url, '_blank');
            }
        },
        reloadPage: async function () {
            // console.log("Reloading page");
            this.loadingPage = true;
            this.failedLoadingPage = false;
            this.successLoadingPage = false;
            await this.getHomePageData();
        },
        lodingPageCheckHandle: async function () {
            // console.log("Starting loading page...");
            try {
                // console.log(this.$store.user);

                // Check if it is the first time that this component will be displayed after login or multiple times.
                if (this.$route.query.firstLogin) {
                    // This component is displayed for the first time after login.
                    // console.log("First login detected");
                    // Remove the query parameter from the URL without reloading the page
                    this.$router.replace({ path: this.$route.path, query: null });
                    if (this.$store.requestSource.includes("webView")){
                        this.$store.tempMobileLogin = true;
                    }
                    // console.log("this.$store.tempMobileLogin: " + this.$store.tempMobileLogin);
                    await this.getHomePageData();
                    // this.$route.query.firstLogin = false;
                }
                else {
                    // Check if the request is from the mobile app or the browser.
                    // console.log("It is not the first login...");
                    // console.log("this.$store.requestSource: " + this.$store.requestSource);
                    // console.log("this.$store.tempMobileLogin: " + this.$store.tempMobileLogin);
                    if (this.$store.requestSource.includes("webView")) {
                        // The request is from the mobile app.
                        // console.log("WebView request...");
                        const { email, mobileId } = this.$route.params;
                        // console.log("email From Vue.js: " + email);
                        // console.log("mobileId From Vue.js: " + mobileId);
                        // console.log(this.$route.params.email);
                        // console.log("this.$store.tempMobileLogin From Vue.js: " + this.$store.tempMobileLogin);
                        if (this.$store.tempMobileLogin) {
                            await this.getHomePageData();
                        }
                        else {
                            if (!this.$route.params || JSON.stringify(this.$route.params) == '{}' || !email || email == '' || !mobileId || mobileId == '') {
                                // this.$store.logOut();
                                // this.$router.push('/start');
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'logout';
                                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                                this.$store.mustLogOut = true;
                            }
                            else {
                                this.loginMobileApp(email, mobileId);
                            }
                        }
                    }
                    else {
                        // The request is from the browser.
                        // console.log("Browser request...");
                        const localStorageUser = JSON.parse(localStorage.getItem('user'));
                        if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                            this.$store.showErrorPopup = true;
                            this.$store.errorPopupTitle = 'logout';
                            this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                            this.$store.mustLogOut = true;
                        }
                        else {
                            const { email, token } = localStorageUser;
                            const userAuth = await this.$store.authUser(email, token);
                            if (!userAuth.status) {
                            if (userAuth.confirmWarning) {
                                this.$store.unconfirmedAccount = true;
                                this.$store.showFooterBackBtn = true;
                                this.$store.user.email = email;
                                this.$router.push('/confirm');
                            }
                            else if (userAuth.error) {
                                this.$store.showMainErrorPage = true;
                            }
                            else {
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'logout';
                                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                                this.$store.mustLogOut = true;
                            }
                            }
                            else {
                                await this.getHomePageData();
                            }
                        }
                    }
                }
                // else {
                //     // This component has already displayed one time at least before.

                //     // console.log("Display component more than 1 time");
                //     const localStorageUser = JSON.parse(localStorage.getItem('user'));
                //     // if (!localStorageUser) {
                //     //     this.$store.logOut();
                //     //     this.$router.push('/start');
                //     // }
                //     console.log("localStorageUser.email: " + localStorageUser.email);
                //     console.log("localStorageUser.token: " + localStorageUser.token);
                //     if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                //         this.$store.showErrorPopup = true;
                //         this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                //         this.$store.mustLogOut = true;
                //     }
                //     else {
                //         const { email, token } = localStorageUser;
                //         const userAuth = await this.$store.authUser(email, token);
                //         console.log("userAuth.status: " + userAuth.status);
                //         console.log("this.$store.requestSource: " + this.$store.requestSource);
                //         if (!userAuth.status) {
                //             // The request is from the mobile app
                //             // console.log("this.$store.requestSource: " + this.$store.requestSource);
                //             if (this.$store.requestSource.includes("webView")) {
                //                 const { email, mobileId } = this.$route.params;
                //                 if (this.$route.params && JSON.stringify(this.$route.params) !== '{}') {
                //                     // The request has params
                //                     // The params will be checked to verify if they are correct or not
                //                     if (email && mobileId) {
                //                         this.loginMobileApp(email, mobileId);
                //                     } else {
                //                         this.loginErrorMsg = 'Invalid login data!';
                //                         this.loginFailed = true;
                //                         this.loginLoading = false;
                //                         this.$store.logOut();
                //                         this.$router.push('/start');
                //                     }
                //                 } else {
                //                     this.$store.logOut();
                //                     this.$router.push('/start');
                //                 }
                //             } else {
                //                 if (userAuth.confirmWarning) {
                //                     this.$store.unconfirmedAccount = true;
                //                     this.$store.showFooterBackBtn = true;
                //                     this.$store.user.email = email;
                //                     this.$router.push('/confirm');
                //                 } else if (userAuth.error) {
                //                     this.$store.showMainErrorPage = true;
                //                 } else {
                //                     // this.$store.logOut();
                //                     // this.$router.push('/start');
                //                     this.$store.showErrorPopup = true;
                //                     this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                //                     this.$store.mustLogOut = true;
                //                 }
                //             }
                //         } else {
                //             await this.getHomePageData();

                //             // this.searchCardsArr[2].redirection_info.push({
                //             //     "id": "248316000001093645",
                //             //     "name": "fit20 Test Studio 2",
                //             //     "language": "nl",
                //             //     "website": "https://fit20hattem.nl",
                //             //     "userRole": "fit20 Client"
                //             // });
                //         }
                //     }
                // }
            } catch (err) {
                console.log(err);
                this.failedLoadingPage = true;
                this.loadingPage = false;
                this.$store.showMainErrorPage = true;

            }
        },
        getHomePageData: async function () {
            // console.log("Getting homepage data");
            // console.log(this.$store.user);
            try {
                // Get user data from local storage.
                const localStorageUser = JSON.parse(localStorage.getItem('user'));
                if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    const data = {
                        email: localStorageUser.email,
                        token: localStorageUser.token,
                        referenceName: 'homePageCards',
                        countryCode: this.$store.user.studiosInfo[0].country_code
                    };
                    // console.log(this.$store.user.studiosInfo);
                    const homePageCardsResponse = await fetch("../../api/bucket/getBucketData", {
                        method: "POST",
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json; charset=UTF-8',
                        },
                        body: JSON.stringify(data),
                    });
                    const homePageCardsResponseJson = await homePageCardsResponse.json();
                    // console.log(homePageCardsResponseJson);


                    if (!homePageCardsResponseJson.status) {
                        this.failedLoadingPage = true;
                    }
                    else {
                        // console.log(this.$store.user);
                        // console.log("this.$store.planning before: " + this.$store.planning);
                        // Loop throw the cards and add the redirect url to each card object if this card is active
                        homePageCardsResponseJson.data.forEach(card => {
                            // card.img_url = `https://storage.googleapis.com/fit20_client_app/imgs/home_titles/${this.$store.user.country_code}/${card.id}.jpg`;
                            // if (card.active) {
                            //     switch (card.id) {
                            //         case "my_results":
                            //             card.redirection_info = this.displayMyPrpgressPageHandle();
                            //             break;
                            //         case "fit20_niews":
                            //             card.redirection_info = this.$store.user.newsLink;
                            //             break;
                            //         case "my_studio":
                            //             card.redirection_info = this.$store.user.studiosInfo;
                            //             break;
                            //         case "my_investment":
                            //             card.redirection_info = '';
                            //             break;
                            //         case "my_appointment":
                            //             card.redirection_info = this.$store.user.studiosInfo;
                            //             break;
                            //     }
                            // }

                            // Check if the user has not planning to remove the card "My appointments" from the cards.
                            // console.log("this.$store.planning: " + this.$store.planning);
                            if (!this.$store.planning & card.id == 'my_appointments') {
                                card.active = false;
                            }

                            if (card.active) {
                                switch (card.id) {
                                    case "my_results":
                                        card.action = this.displayMyPrpgressPageHandle;
                                        break;
                                    case "fit20_news":
                                        card.action = this.getStudiosHandle; // This function should be updated because the studios info and news link will be fetched with the login. If there is no studios info, the user can not log in
                                        break;
                                    case "my_studio":
                                        card.action = this.getStudiosHandle; // This function should be updated because the studios info and news link will be fetched with the login. If there is no studios info, the user can not log in
                                        break;
                                    case "my_investment":
                                        card.action = this.testClick;
                                        break;
                                    case "my_appointments":
                                        card.action = this.navigateToAppointmetsPage;
                                        break;
                                }
                            }
                            // else {
                            //     if (card.id == 'my_appointments') {
                            //         card.action = this.navigateToAppointmetsPage;
                            //     }
                            // }
                        });



                        // Sort the cards ascending by their order property and set the temperary cards in the first of the array
                        homePageCardsResponseJson.data.sort((a, b) => {
                            // First sort by 'fixed_card' status (false first)
                            if (a.fixed_card !== b.fixed_card) {
                                return a.fixed_card ? 1 : -1;
                            }
                            // If 'fixed_card' status is the same, sort by index
                            return a.index - b.index;
                        });
                        this.$store.homepageCards = homePageCardsResponseJson.data;
                        this.cards = homePageCardsResponseJson.data;
                        this.searchCardsArr = [...this.cards];
                        this.successLoadingPage = true;
                        // console.log(this.searchCardsArr);
                    }
                    this.loadingPage = false;
                }
            }
            catch (err) {
                console.log(err);
                this.loadingPage = false;
                this.failedLoadingPage = true;
            }
        },
        getStudiosHandle: async function (cardId) {
            // console.log("this.$store.user.zohoId: " + this.$store.user.zohoId);
            // console.log("this.$store.user.email: " + this.$store.user.email);
            // console.log("this.$store.user.token: " + this.$store.user.token);
            // console.log("this.$store.user.moduleType: " + this.$store.user.moduleType);
            this.optionsType = '';
            try {
                if (this.$store.user.studiosInfo.length < 1) {
                    // console.log("Getting studios info and news link...");
                    // this.loadingPage = true;
                    this.failedGetStudiosInfo = false;
                    this.failedGetNewsLink = false;
                    this.failedGetUserProgress = false;
                    this.faildGetData = false;
                    const studiosArrResponse = await getUserStudios(this.$store.user.email, this.$store.user.token, this.$store.user.moduleType, this.$store.user.zohoId);
                    // console.log(studiosArrResponse);
                    if (!studiosArrResponse.status) {
                        if (studiosArrResponse.invalidToken) {
                            this.$store.showErrorPopup = true;
                            this.$store.errorPopupTitle = 'logout';
                            this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                            this.$store.mustLogOut = true;
                        }
                        else {
                            if (cardId === 'fit20_news') {
                                // this.failedGetNewsLink = true;
                                this.$store.errorPopupTitle = 'redirect_failed';
                                this.$store.errorPopupMsg = 'no_news_found';
                            }
                            else if (cardId === 'my_studio') {
                                // this.failedGetStudiosInfo = true;
                                this.$store.errorPopupTitle = 'redirect_failed';
                                this.$store.errorPopupMsg = 'no_studios_found';
                            }
                            this.$store.showErrorPopup = true;
                            // this.loadingPage = false;
                        }
                    }
                    else {
                        this.$store.user.studiosInfo = studiosArrResponse.data.studiosInfoArr;
                        this.$store.user.newsLink = studiosArrResponse.data.newsLink;
                        this.optionsType = cardId;
                    }
                }

                // if (this.studiosOptionsArr.length === 1) {
                //     this.studiosOptionsArr.push(
                //         {
                //             "id": "248316000001093645",
                //             "name": "fit20 Test Studio 2",
                //             "language": "nl",
                //             "website": "https://fit20hattem.nl",
                //             "userRole": "fit20 Client"
                //         }
                //     )
                // }

                // this.studiosOptionsArr = [];
                // this.$store.user.newsLink = '';

                if (cardId === 'fit20_news') {
                    // console.log("Handling open news link...");
                    if (!this.$store.user.newsLink || this.$store.user.newsLink == '') {
                        // console.log("No news link found...");
                        // this.failedGetNewsLink = true;
                        this.$store.errorPopupTitle = 'redirect_failed';
                        this.$store.errorPopupMsg = 'no_news_found';
                        this.$store.showErrorPopup = true;
                        // this.loadingPage = false;
                    }
                    else {
                        // console.log("Opening news link...");
                        await this.openUrlClickHandle(this.$store.user.newsLink);
                        // this.loadingPage = false;
                        // window.open(this.$store.user.newsLink, '_blank');
                    }
                }
                else if (cardId === 'my_studio') {
                    // console.log("Card id is my_stuio...");
                    if (this.$store.user.studiosInfo.length < 1) {
                        // this.failedGetStudiosInfo = true;
                        this.$store.errorPopupTitle = 'redirect_failed';
                        this.$store.errorPopupMsg = 'no_studios_found';
                        this.$store.showErrorPopup = true;
                        // this.loadingPage = false;
                    }
                    else if (this.$store.user.studiosInfo.length == 1) {
                        // const response = await fetch(this.$store.user.studiosInfo[0].website, { method: 'HEAD' });
                        // // if (response.type === 'opaque') {
                        // //     await this.openUrlClickHandle(this.$store.user.studiosInfo[0].website);
                        // // }
                        // if (response.ok) {
                        //     await this.openUrlClickHandle(this.$store.user.studiosInfo[0].website);
                        // }
                        // else {
                        //     this.$store.errorPopupMsg = 'no_studios_found';
                        //     this.$store.showErrorPopup = true;
                        //     this.loadingPage = false;
                        // }

                        if (this.$store.user.studiosInfo[0].website && this.$store.user.studiosInfo[0].website !== '') {
                            await this.openUrlClickHandle(this.$store.user.studiosInfo[0].website);
                            // await this.openUrlClickHandle("https://www.fit20.com/");
                        }
                        else {
                            this.$store.errorPopupTitle = 'redirect_failed';
                            this.$store.errorPopupMsg = 'no_studios_found';
                            this.$store.showErrorPopup = true;
                        }
                    }
                    else {
                        // console.log("this.$store.user.studiosInfo.length > 1");
                        this.$store.showStudiosOptionsPage = true;
                        this.optionsType = cardId;
                        // this.loadingPage = false;
                    }
                }
                // this.loadingPage = false;
            }
            catch (err) {
                console.log(err);
                // if (cardId === 'fit20_news') {
                //     this.failedGetNewsLink = true;
                // }
                // else if (cardId === 'my_studio') {
                //     this.failedGetStudiosInfo = true;
                // }
                // this.faildGetData = true;
                this.$store.errorPopupTitle = 'unexpected_error';
                this.$store.errorPopupMsg = 'something_went_wrong_try_again';
                this.$store.showErrorPopup = true;
                // this.loadingPage = false;
            }
        },
        displayChangePasswordPage: function () {
            this.$router.push('/change-password');
        },
        displayMyPrpgressPageHandle: async function () {
            try {
                this.$store.user.progressData = false;
                this.loadingPage = true;
                this.$store.activeNavBarButton = '';

                const localStorageUser = JSON.parse(localStorage.getItem('user'));
                if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    const dataObj = {
                        'email': localStorageUser.email,
                        'token': localStorageUser.token,
                    };

                    const progressDataResponse = await fetchProgressData(dataObj);
                    // console.log(progressDataResponse);
                    if (!progressDataResponse.status) {
                        if (progressDataResponse.noDataFounded) {
                            this.$store.errorPopupTitle = 'unfortunately';
                            this.$store.errorPopupMsg = progressDataResponse.message;
                        }
                        else {
                            this.$store.errorPopupTitle = 'unexpected_error';
                            this.$store.errorPopupMsg = 'something_went_wrong_try_again';
                        }
                        this.$store.showErrorPopup = true;
                        this.loadingPage = false;
                        this.$store.activeNavBarButton = 'home';
                    }
                    else {
                        this.$store.user.progressData = progressDataResponse.data;
                        this.$router.push("/my-progress");
                    }
                }
            }
            catch (err) {
                console.log(err);
                this.$store.errorPopupTitle = 'unexpected_error';
                this.$store.errorPopupMsg = 'something_went_wrong_try_again';
                this.$store.showErrorPopup = true;
                this.loadingPage = false;
                this.$store.activeNavBarButton = 'home';
            }
        },
        navigateToUrl: async function (url) {
            if (this.$store.requestSource.includes("webView")) {
                try {
                    await window.flutter_webView_open_external_url.postMessage(JSON.stringify({ url: url }));
                }
                catch (err) {
                    console.log('Error in sending url to webview');
                    console.log(err);
                }
            }
            else {
                // window.location.href = url;
                window.open(url, '_blank').focus();
            }
        },
        // closeSearchBar: function () {
        //     this.searchCardsArr = [...this.cards];
        //     this.$refs.searchBar.value = '';
        //     this.$store.showHomePageSearchBar = false;
        //     this.$store.activeNavBarButton = 'home';
        // },
        searchHandle: function (value) {
            // console.log(this.searchCardsArr);
            // console.log(value);
            let searchArr = [];

            this.searchCardsArr = [...this.cards];

            this.searchCardsArr.forEach(card => {
                if (card.id.toLowerCase().includes(value.toLowerCase())) {
                    searchArr.push(card);
                }
            });

            // console.log(searchArr);

            if (value != '') {
                this.searchCardsArr = searchArr;
            }
            else {
                this.searchCardsArr = this.cards;
            }
        },
        backToHomePageHandle: function () {
            // this.studiosOptionsArr = [];
            this.$store.showStudiosOptionsPage = false;
        },
        closeErrPopup: function () {
            this.failedGetStudiosInfo = false;
            this.failedGetNewsLink = false;
            this.failedGetUserProgress = false;
            this.faildGetData = false;
        },
        // testClick: function () {
        //     console.log('test');
        // },
        navigateToAppointmetsPage: function () {
            this.$router.push('/scheduling');
            this.$store.activeNavBarButton = '';
        },
    },
    watch: {
        // test: {
        //     deep: true,
        //     handler: function (newValue) {
        //         console.log("newValue = " + newValue);
        //     }
        // }
    },
    async created() {
        // console.log(this.$route.params);
        // console.log(this.$store.user);
        // console.log(this.$store.allLanguages);

        if (!this.$store.homepageCards) {
            await this.lodingPageCheckHandle();
        }
        else {
            this.cards = this.$store.homepageCards;
            this.searchCardsArr = [...this.cards];
            this.successLoadingPage = true;
            this.loadingPage = false;
        }

        window.addEventListener('flutter_navToPage', async () => {
            const path = window.location.pathname;
            // console.log('Path:', path);
            if (path === '/home') {
                // await this.lodingPageCheckHandle();
                if (!this.$store.homepageCards) {
                    await this.lodingPageCheckHandle();
                }
                else {
                    this.cards = this.$store.homepageCards;
                    this.searchCardsArr = [...this.cards];
                    this.successLoadingPage = true;
                    this.loadingPage = false;
                }
            }
        });


        // try {
            // console.log(this.$store.user);

        //     // Check if it is the first time that this component will be displayed after login or multiple times.
        //     if (this.$route.query.firstLogin) {
        //         // This component is displayed for the first time after login.
        //         console.log("First login detected");
        //         // Remove the query parameter from the URL without reloading the page
        //         this.$router.replace({ path: this.$route.path, query: null });
        //         await this.getHomePageData();
        //         // this.$route.query.firstLogin = false;
        //     }
        //     else {
        //         // This component has already displayed one time at least before.

        //         const localStorageUser = JSON.parse(localStorage.getItem('user'));
        //         if (!localStorageUser) {
        //             this.$store.logOut();
        //             this.$router.push('/start');
        //         }
        //         else {
        //             const {email, token} = localStorageUser;
        //             const userAuth = await this.$store.authUser(email, token);
        //             // const localStorageUser = JSON.parse(localStorage.getItem('user'));
        //             if (!userAuth.status) {
        //                 // The request is from the mobile app
        //                 // console.log("this.$store.requestSource: " + this.$store.requestSource);
        //                 if (this.$store.requestSource.includes("webView")) {
        //                     const { email, mobileId } = this.$route.params;
        //                     if (this.$route.params && JSON.stringify(this.$route.params) !== '{}') {
        //                         // The request has params
        //                         // The params will be checked to verify if they are correct or not
        //                         if (email && mobileId) {
        //                             this.loginMobileApp(email, mobileId);
        //                         }
        //                         else {
        //                             this.loginErrorMsg = 'Invalid login data!';
        //                             this.loginFailed = true;
        //                             this.loginLoading = false;
        //                             this.$store.logOut();
        //                             this.$router.push('/start');
        //                         }
        //                     }
        //                     else {
        //                         this.$store.logOut();
        //                         this.$router.push('/start');
        //                     }
        //                 }
        //                 else {
        //                     if (userAuth.confirmWarning) {
        //                         this.$store.unconfirmedAccount = true;
        //                         this.$store.showFooterBackBtn = true;
        //                         this.$store.user.email = email;
        //                         this.$router.push('/confirm');
        //                     }
        //                     else if (userAuth.error) {
        //                         this.$store.showMainErrorPage = true;
        //                     }
        //                     else {
        //                         this.$store.logOut();
        //                         this.$router.push('/start');
        //                     }
        //                 }
        //             }
        //             else {
        //                 await this.getHomePageData();

        //                 // this.searchCardsArr[2].redirection_info.push({
        //                 //     "id": "248316000001093645",
        //                 //     "name": "fit20 Test Studio 2",
        //                 //     "language": "nl",
        //                 //     "website": "https://fit20hattem.nl",
        //                 //     "userRole": "fit20 Client"
        //                 // });
        //             }
        //         }
        //     }
        // }
        // catch(err) {
        //     console.log(err);
        //     this.failedLoadingPage = true;
        //     this.loadingPage = false;
        // }



        // console.log("Language: " + this.language);
        // console.log("!this.$store.checkLoggedinUser(): " + !this.$store.checkLoggedinUser());
        // console.log("this.$store.requestSource: " + this.$store.requestSource);
        // console.log("this.$store.sessionToken: " + this.$store.sessionToken);
        // const loggedInUser = await this.$store.checkLoggedinUser();
        // console.log("loggedInUser: " + loggedInUser);
        // if (!loggedInUser) {
        //     // The request is from the mobile app
        //     console.log("this.$store.requestSource: " + this.$store.requestSource);
        //     if (this.$store.requestSource.includes("webView")) {
        //         const { email, mobileId } = this.$route.params;
        //         console.log("email: " + email);
        //         console.log("mobileId: " + mobileId);
        //         if (this.$route.params && JSON.stringify(this.$route.params) !== '{}') {
        //             // The request has params
        //             // The params will be checked to verify if they are correct or not
        //             if (email && mobileId) {
        //                 this.loginMobileApp(email, mobileId);
        //             }
        //             else {
        //                 this.loginErrorMsg = 'Invalid login data!';
        //                 this.loginFailed = true;
        //                 this.loginLoading = false;
        //                 this.$router.push('/start');
        //             }
        //         }
        //         else {
        //             this.$router.push('/start');
        //         }
        //     }
        //     else {
        //         this.loginFailed = true;
        //         this.loginLoading = false;
        //         this.$router.push('/start');
        //     }
        // }

        // console.log(this.$store.user);
    },
}
</script>

<style>
.home-page-component-container {
    width: 100%;
    height: 100vh;
    position: relative;
    /* border: 1px solid; */
}

.home-page-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.home-page-component-container .home-page-container {
    /* height: 1000px; */
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
}

.home-page-component-container .home-page-container::-webkit-scrollbar {
    display: none;
}

.home-page-component-container .spinner-container {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.home-page-component-container .spinner {
    width: 20% !important;
    max-width: 100px !important;
}

.home-page-component-container .cards-list-container {
    position: relative;
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.home-page-component-container .search-bar-container {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.home-page-component-container .search-bar {
    flex: 1;
    font-size: 20px;
    padding: 15px;
    border: 2px solid #a0a1a3;
    border-radius: 30px;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    outline-color: #009df4;
    opacity: .8;
}

.home-page-component-container .close-btn-container {
    width: 40px;
}

.home-page-component-container .close-btn {
    width: 100%;
    transition: transform 0.5s ease;
}

.home-page-component-container .close-btn-container:hover .close-btn {
    cursor: pointer;
    transform: rotate(-90deg);
}

.home-page-component-container .hide {
    visibility: hidden;
    height: 0;
    opacity: 0;
    transform: translateY(-50px);
}

.home-page-component-container .show {
    height: max-content;
    z-index: 10;
    opacity: 1;
    transform: translateY(0);
    background: #fff;
}

.home-page-component-container .cards-list {
    /* width: 100%; */
    /* border: 1px solid; */
    padding: 10px 10px 0;
}

.home-page-component-container .card-item {
    position: relative;
    height: calc(50vw - 20px);
    min-height: 235px;
    max-height: 285px;
    min-width: 500px;
    margin-bottom: 12px;
    overflow: hidden;
    border-radius: 15px;
    cursor: pointer;
    /* border: 1px solid red; */
}

.home-page-component-container .card-item:hover {
    border: 2px solid #009df4;
}

.home-page-component-container .hidden {
    display: none;
}

.home-page-component-container .coming-soon-container {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, .4);
}

.home-page-component-container .coming-soon-container p {
    color: #92d400;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 50px;
    transform: rotate(-20deg);
    text-align: center;
}

.home-page-component-container .card-bg-container {
    width: 100%;
    height: 100%;
}

.home-page-component-container .card-bg-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.home-page-component-container .card-title-container {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 20px;
    /* line-height: 80px; */
    /* border: 1px solid red; */
}

[dir="rtl"] .home-page-component-container .card-title-container {
    left: auto;
    right: 0;
    /* background: #616365; */
    background: rgba(97, 99, 101, 0.8);
    border-radius: 0 0 0 12px;
}

.home-page-component-container .card-title-container p {
    color: #ffffff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 40px;
    letter-spacing: -1px;
}

.home-page-component-container .forward-arrow-icon-container {
    width: 80px;
    height: 80px;
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0 18px 18px 0;
    overflow: hidden;
    border-radius: 50%;
    background: #ffffff;
    /* padding: 0px 10px 7px 10px; */
    /* line-height: 80px; */
    /* border: 1px solid red; */
}

[dir="rtl"] .home-page-component-container .forward-arrow-icon-container {
    right: auto;
    left: 0;
    margin: 0 0 18px 18px;
    /* padding: 0px 10px 7px 10px; */
    /* line-height: 80px; */
    /* border: 1px solid red; */
}

.home-page-component-container .forward-arrow-icon-container img {
    width: 100%;
    transform: scale(1.4);
    transform-origin: center;
}

[dir="rtl"] .home-page-component-container .forward-arrow-icon-container img {
    transform: rotate(180deg) scale(1.4);
}

.home-page-component-container .studios-options-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* border: 1px solid; */
}

.home-page-component-container .studios-options-page-wrapper {
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
    /* border: 1px solid red; */
}

.home-page-component-container .studios-options-list-container {
    width: 100%;
    padding: 25px 10px;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    /* border: 1px solid blue; */
}

.home-page-component-container .studios-options-item {
    /* width: 50%; */
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    padding: 6px 0 10px;
    background: #92d400;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
    margin: auto;
    margin-bottom: 20px;
}

.home-page-component-container .back-to-homepage-btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.home-page-component-container .back-to-homepage-btn-container p {
    color: #009df4;
    cursor: pointer;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    text-align: center;
}

.home-page-component-container .fialed-loading-page-container {
    flex: 1;
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.home-page-component-container .info-text-container {
    width: 100%;
    max-width: 475px;
    padding: 5% 0 25px;
}

.home-page-component-container .info-text-container .info-text {
    font-size: 29px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 32px;
    /* border: 1px solid red; */
    /* padding-bottom: 2px; */
}

.home-page-component-container .reload-btn-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
}

.home-page-component-container .reload-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

@media (min-width: 1070px) {
    .home-page-component-container .cards-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        /* padding: 25px; */
    }

    .home-page-component-container .card-item {
        width: 49%;
        height: calc((100vh / 1.85) - 175px);
    }
}

@media (max-width: 1069px) {
    .home-page-component-container .cards-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        /* border: 1px solid; */
    }

    .home-page-component-container .card-item {
        width: 60%;
        min-width: 625px;
    }
}

@media (max-width: 768px) {
    .home-page-component-container .card-item {
        width: 100%;
        min-width: 0;
        min-height: 140px;
    }

    .home-page-component-container .card-title-container p {
        font-size: calc(14px + 3.5vw);
    }

    .home-page-component-container .coming-soon-container p {
        font-size: calc(14px + 3vw);
    }

    .home-page-component-container .studios-options-item {
        width: 85%;
        min-width: 175px;
    }
}

@media (max-width: 550px) {
    .home-page-component-container .forward-arrow-icon-container {
        width: 65px;
        height: 65px;
    }
}

@media (max-width: 425px) {
    .home-page-component-container .forward-arrow-icon-container {
        width: 55px;
        height: 55px;
        margin: 0 14px 14px 0;
    }

    .home-page-component-container .info-text-container .info-text {
        font-size: 26px;
    }

    .home-page-component-container .reload-btn {
        font-size: 24px;
    }

    .home-page-component-container .studios-options-item {
        font-size: 26px;
    }
}

@media (max-width: 375px) {
    .home-page-component-container .forward-arrow-icon-container {
        width: 50px;
        height: 50px;
    }
}

@media (max-width: 320px) {
    .home-page-component-container .forward-arrow-icon-container {
        width: 45px;
        height: 45px;
    }

    .home-page-component-container .info-text-container {
        padding-bottom: 25px;
    }

    .home-page-component-container .studios-options-item {
        font-size: 24px;
    }
}
</style>